export default {
    ajaxLoadingApp: () => {
        jQuery('body').append("<div class='ajax-overlay'><i class='porto-loading-icon'></i></div>")
    },

    ajaxLoadingRemoveApp: () => {
        jQuery('.ajax-overlay').remove()
    },

    ajaxLoadingModal: (name) => {
        jQuery('#content-'+name).append(
            `<div class="ajax-overlay" id="porto-loading-modal-${name}" >
                <i class="porto-loading-icon"></i>
            </div>`
        )
    },

    ajaxLoadingRemoveModal: (name) => {
        jQuery('#porto-loading-modal-'+name).remove()
    }
}